module.exports = __webpack_public_path__ + "img/77289.46da67a1.svg";